import List from '@service-victoria/component-library/components/List';
import Text from '@service-victoria/component-library/components/Text';
import React from 'react';

export default function WhatYouNeed() {
  return (
    <>
      <List
        type='disc'
        items={[
          'ABN',
          'address for the business using the voucher',
          'driver licence or learner permit, Victorian seniors card or proof of age card',
          'mobile phone number and email address'
        ]}
      />
      <Text.Body>
        We can’t accept a Commonwealth seniors card. If you don’t have a Victorian seniors card,
        choose a different form of ID.
      </Text.Body>
    </>
  );
}
